export type ArtFrame = { x: number; y: number; width: number; height: number };

/** Position-only safe-area updates matter just as much as a resized bitmap. */
export function tradeFramesMatch(a: ArtFrame | null | undefined, b: ArtFrame | null | undefined): boolean {
  return !!a && !!b && (["x", "y", "width", "height"] as const).every(key => Math.abs(a[key] - b[key]) < .1);
}

/** Contain a bitmap in a known frame; bottom alignment keeps all plinths on one baseline. */
export function fitTradeArt(source: { width: number; height: number }, frame: ArtFrame, bottom = true): ArtFrame {
  const scale = Math.min(frame.width / Math.max(1, source.width), frame.height / Math.max(1, source.height));
  const width = source.width * scale, height = source.height * scale;
  return { x: frame.x + (frame.width - width) / 2, y: frame.y + (frame.height - height) * (bottom ? 1 : .5), width, height };
}
